// frontend/src/theme.js
export const colors = {
  bgGradient: 'radial-gradient(circle, #4a1f4c, #150a17)',

  textPrimary: '#ffffff',
  textMuted: 'rgba(255,255,255,0.65)',
  textFaint: 'rgba(255,255,255,0.4)',

  gold: '#BF953F',
  goldMuted: 'rgba(191,149,63,0.5)',
  goldActiveBg: 'rgba(191,149,63,0.3)',

  odds: '#4ade80',
  negative: '#ef4444',
  freePlay: '#a855f7',
  pending: '#f97316',
  live: '#ef4444',

  cardBg: 'rgba(255,255,255,0.05)',
  cardBgActive: 'rgba(191,149,63,0.4)',
  sectionBg: 'rgba(255,255,255,0.03)',
  surfaceBg: 'rgba(0,0,0,0.25)',

  shadowCard: '0 4px 14px rgba(0,0,0,0.35)',
  shadowRaised: '0 6px 22px rgba(0,0,0,0.45)',
  shadowSubtle: '0 2px 8px rgba(0,0,0,0.25)',
};

export const fontFamily = 'Nunito, sans-serif';

// Opaque surface for native <select> controls. The theme's card backgrounds are
// translucent white, which makes the browser's native dropdown popup render as
// white-on-white (invisible option text). Use these on <select> and every
// <option> so the popup list stays readable.
export const selectSurface = '#1a0822';
export const optionStyle = { background: selectSurface, color: colors.textPrimary };
